'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _home = require('redux/modules/home');

var homeAction = _interopRequireWildcard(_home);

var _session = require('redux/modules/session');

var _toast = require('redux/modules/toast');

var _reactRouterRedux = require('react-router-redux');

var _HomeLanding = require('components/Home/HomeLanding');

var _HomeLanding2 = _interopRequireDefault(_HomeLanding);

var _HomeWhat = require('components/Home/HomeWhat');

var _HomeWhat2 = _interopRequireDefault(_HomeWhat);

var _SeeInspiration = require('components/Home/SeeInspiration');

var _SeeInspiration2 = _interopRequireDefault(_SeeInspiration);

var _FeaturedTrips = require('components/Home/FeaturedTrips');

var _FeaturedTrips2 = _interopRequireDefault(_FeaturedTrips);

var _AsSeenOn = require('components/Home/AsSeenOn');

var _AsSeenOn2 = _interopRequireDefault(_AsSeenOn);

var _AsSeenOn3 = require('components/Pachantiew/AsSeenOn');

var _AsSeenOn4 = _interopRequireDefault(_AsSeenOn3);

var _FeaturedReviews = require('components/Home/FeaturedReviews');

var _FeaturedReviews2 = _interopRequireDefault(_FeaturedReviews);

var _FeaturedReviews3 = require('components/Pachantiew/FeaturedReviews');

var _FeaturedReviews4 = _interopRequireDefault(_FeaturedReviews3);

var _AboutLocalExperts = require('components/Home/AboutLocalExperts');

var _AboutLocalExperts2 = _interopRequireDefault(_AboutLocalExperts);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Reset = require('components/Nav/Reset');

var _Reset2 = _interopRequireDefault(_Reset);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Home: {
    displayName: 'Home'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Home/Home.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { changeLocale } from 'redux/modules/translation';


// import HomeLanding from 'components/Home/HomeLanding';

// import TourCategory from 'components/Pre/TourCategory';
// import HomeTourCategory from 'components/Home/HomeTourCategory';
// import FeaturedLocalExpert from 'components/Home/FeaturedLocalExpert';


// import Login from 'components/Nav/Login';
// import { getInstantUrl } from 'utils/helpers.js';

var Home = _wrapComponent('Home')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _home.isLoaded)(getState())) {
      return dispatch((0, _home.load)());
      // .then(()=> dispatch(changeLocale('de')));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    home: state.home.data,
    headTags: state.info.headTags,
    error: state.home.error,
    loading: state.loader.loading,
    isOpenReset: state.session.openReset,
    resetPosted: state.session.resetPosted,
    query: state.routing.locationBeforeTransitions.query,
    messages: state.language.messages,
    locale: state.language.locale,
    userConfig: state.info.userConfig,
    siteConfigs: state.info.siteConfigs,
    instantPushed: state.toast.instantPushed,
    isVisitBooking: state.session.isVisitBooking,
    isLoggedIn: state.session.isLoggedIn
  };
},
// {...homeAction, push, openReset, openLogin, setLoginSignupCallback})
(0, _extends3.default)({}, homeAction, { push: _reactRouterRedux.push, openReset: _session.openReset, openLogin: _session.openLogin, setLoginSignupCallback: _session.setLoginSignupCallback, pushInstant: _toast.pushInstant })), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref2, [this].concat(args))), _this), _this.onCloseReset = function () {
      _this.props.openReset(false);
    }, _this.redirect = function () {
      // this.props.openLoginSignup(false);
      // if (this.props.query && this.props.query.redirect) {
      //   this.setState({openForceLogin: false}); // eslint-disable-line
      _this.props.push(_this.props.query.redirect);
      // }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentDidMount',

    // state = {
    //   openForceLogin: false
    // }
    value: function componentDidMount() {
      // const instantUrl = getInstantUrl();
      if (this.props.query && this.props.query.redirect) {
        // this.setState({openForceLogin: true}); // eslint-disable-line
        if (!this.props.isLoggedIn) {
          this.props.setLoginSignupCallback(this.redirect);
          this.props.openLogin();
        } else {
          this.redirect.bind(this)();
        }
      }
      if (this.props.params && this.props.params.token) {
        this.props.openReset();
      }
      // if (!this.props.instantPushed && this.props.siteConfigs.instantEnabled && instantUrl && !this.props.isVisitBooking) {
      // setTimeout(()=> {
      // this.props.pushInstant();
      // }, 1800);
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          messages = _props.messages,
          headTags = _props.headTags,
          locale = _props.locale;

      var pachantiewLandingImage = require('theme/images/pachantiew-mobile-background.jpg');
      var LandingImage = require('theme/images/mobile-background.jpg');
      return _react3.default.createElement(
        'div',
        null,
        locale === 'th' ? _react3.default.createElement(_reactHelmet2.default, {
          meta: [{ 'property': 'og:image', 'content': pachantiewLandingImage }, { 'property': 'og:description', 'content': 'พาเที่ยวโดยคนไทยในต่างประเทศเริ่มต้นที่ 1,500 บาทต่อวัน' }, { 'property': 'og:site_name', 'content': 'พาฉันเที่ยว - ไปได้ไกลกว่าทัวร์ ไปได้ทั่วกว่าเที่ยวเอง' }]
        }) : _react3.default.createElement(_reactHelmet2.default, {
          meta: [{ 'property': 'og:image', 'content': LandingImage }, { 'property': 'og:site_name', 'content': headTags && headTags['/'] && headTags['/'].title || messages.sitename + ' - ' + messages['home.title'] }]
        }),
        _react3.default.createElement(_HomeLanding2.default, null),
        this.props.userConfig.showHomeInspirations && _react3.default.createElement(_SeeInspiration2.default, { inspirationLayouts: this.props.home.inspiration_layouts, homeStyle: true, bgColor: '#f2f2f2' }),
        this.props.userConfig.showFeaturedTrips && _react3.default.createElement(_FeaturedTrips2.default, { featuredTrips: this.props.home.featured_trips, homeStyle: true }),
        _react3.default.createElement(_AboutLocalExperts2.default, { locale: locale }),
        _react3.default.createElement(_HomeWhat2.default, null),
        locale === 'th' ? _react3.default.createElement(_FeaturedReviews4.default, null) : _react3.default.createElement(_FeaturedReviews2.default, { reviews: this.props.home.featured_reviews }),
        locale === 'th' ? _react3.default.createElement(_AsSeenOn4.default, null) : _react3.default.createElement(_AsSeenOn2.default, null),
        _react3.default.createElement(
          _Modal2.default,
          { isOpen: this.props.isOpenReset, noClose: !this.props.resetPosted, onClose: this.props.resetPosted ? this.onCloseReset : function () {}, id: 'reset' },
          _react3.default.createElement(_Reset2.default, { token: this.props.params && this.props.params.token })
        )
      );
    }
  }]);
  return Home;
}(_react2.Component), _class2.propTypes = {
  home: _react2.PropTypes.object,
  headTags: _react2.PropTypes.object,
  error: _react2.PropTypes.string,
  loading: _react2.PropTypes.bool,
  load: _react2.PropTypes.func.isRequired,
  query: _react2.PropTypes.object,
  push: _react2.PropTypes.func,
  params: _react2.PropTypes.object,
  openReset: _react2.PropTypes.func,
  isOpenReset: _react2.PropTypes.bool,
  resetPosted: _react2.PropTypes.bool,
  isVisitBooking: _react2.PropTypes.bool,
  openLogin: _react2.PropTypes.func,
  setLoginSignupCallback: _react2.PropTypes.func,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  userConfig: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  pushInstant: _react2.PropTypes.func,
  instantPushed: _react2.PropTypes.bool,
  isLoggedIn: _react2.PropTypes.bool
}, _temp2)) || _class) || _class));

exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 475
// module chunks = 47